module.exports = __webpack_public_path__ + "media/src/assets/Images/FilterOpenArrow-8676550ac9aeff6e3e8f8ee99446fb1a.svg";